export default __webpack_public_path__ + "static/media/Group 5209.93346874.svg";